// eslint-disable-next-line import/prefer-default-export
export const SENTRY_DSN =
  'https://8567ec420cf04ce3b7f4b82d5fff70f7@o168020.ingest.sentry.io/5398612';
